export default str => {
  const parts = str.includes('@') ? str.split('@')[0].split('.') : str.split(' ')

  return parts.map(part => part.charAt(0))
    .join(' ')
}



// WEBPACK FOOTER //
// ./src/filters/avatarName.js